export default __webpack_public_path__ + "static/media/low-thickness.f3b8ec8a.svg";